// extracted by mini-css-extract-plugin
export default {"introduce":"index_introduce_5HSe2","pic":"index_pic_gML8a"};